module.exports = __webpack_public_path__ + "img/lc.d451e533.svg";